import uniqBy from 'lodash/uniqBy';

import {
  PathwayUserReport,
  UserPlanSummaryReport,
} from '@cfa/pathway-fe-shared/xp';

import { processUserName } from '@/services/modelHelper';

export interface TeamMemberVM
  extends
    Record<string, unknown>,
    Pick<PathwayUserReport, 'name'>,
    Partial<Pick<PathwayUserReport, 'id' | 'locations' | 'startDate'>>,
    Partial<Pick<UserPlanSummaryReport, 'plansAssigned' | 'plansCompleted'>> {
  displayName: string;
  startDateTime?: number;
}

export const fromUserPlanSummaryReports = (
  data: UserPlanSummaryReport[],
): TeamMemberVM[] =>
  uniqBy(
    data.map(({ user, plansAssigned, plansCompleted }) => ({
      id: user.id,
      name: user.name,
      displayName: processUserName(user),
      locations: user.locations,
      startDate: user.startDate,
      startDateTime: new Date(user.startDate ?? Infinity).getTime(),
      plansAssigned,
      plansCompleted,
    })),
    'id',
  );
